// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2C2UF","title":"Info_title__U8MrS","selects":"Info_selects__s4Hv7","requiredAsterisk":"Info_requiredAsterisk__5I8ks"};